import React, { useState, useGlobal, useEffect } from 'reactn';
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { guardarCalidadFinal, obtenerRegistroFinal, obtenerRegistrosCalidadFinalDia, obtenerFiltrosCalidadTodos } from '../../service/Calidad';
import { Dropdown } from 'primereact/dropdown';
import { Message } from 'primereact/message';
import { noHaSidoClausurado } from '../../service/Ciclos';
import { obtenerInicioDia } from '../../service/fechas';
import SeccionFormulario from '../common/SeccionFormulario';
import ContenedorInput from '../common/ContenedorInput';
import ModalSeleccionarDefectos from './ModalSeleccionarDefectos';
import { getProductoYVariedadString, getObjetoPorID, DeepClone, noHayVariosPuntos, sumarNumerosArrayPorCampo, checkIfStringIsNumber } from '../../util/functions';
import ContenedorHeader from '../common/ContenedorHeader';
import icono from '../../images/icons/external-icon.svg';
import { getPresentacionesFiltradosYOrdenadosPorInvernadero } from '../../service/ProductosYVariedades';
import { ORDER_BY_PRESENTACION } from '../../service/constants/Calidad.const';
import { TIPO_CANTIDAD } from 'service/constants/ProductosYVariedades.const';
import { mapDeDataDropdownDePresentaciones } from './utils/registroFinal.utils';
import DropdownPresentacionesHTG from 'components/common/input_components/DropdownPresentacionesHTG.comp';

const inicial = {
  presentacion_ref: "",
  peso_real_caja: "",
  peso_promedio_fruto: "",
  numero_racimos: "",
  frutos_racimo: "",
  comentario: "",
  no_racimos: { 4: "", 5: "", 6: "" },
  subVariedad_ref: "",
  proveedor: "",
  presentacion_ref: ""
}
const PRODUCTOS_CON_RACIMOS = ["TOV", "CHERRY", "COCKTAIL"];
const RegistroFinal = (props) => {
  const [state, setState] = useState(inicial);
  const [, setNombreModulo] = useGlobal("nombreModulo");
  const [, setHabilitadoSelectorCiclo] = useGlobal("habilitadoSelectorCiclo");
  const [clientes] = useGlobal("clientes")
  const [invernadero] = useGlobal("invernadero");
  const [ciclo,] = useGlobal("ciclo")
  const [ciclos,] = useGlobal("ciclos")
  const [usuario,] = useGlobal("usuario")
  const [, setCargando] = useGlobal("cargando")
  const [defectos] = useGlobal("defectos");
  const [defectosEditados, setDefectosEditados] = useState([]);
  const [defectosSeleccionados, setDefectosSeleccionados] = useState([]);
  const [mostrarModalDefectos, setMostrarModalDefectos] = useState(false)
  const [presentaciones] = useGlobal("presentaciones")
  const [producto, setProducto] = useState();
  const [errores, setErrores] = useState([]);
  const [editing] = useState(props.match.params.registroID ? true : false)
  const [registroID] = useState(props.match.params.registroID)
  const [datosCargados] = useGlobal("datosCargadosCalidad");

  const [productosYVariedades] = useGlobal("productosYVariedades")
  const [proveedores] = useGlobal("proveedores");
  const [presentacionesFiltrados, setPresentacionesFiltrados] = useState([])
  const [mezclaVariedades, setMezclaVariedades] = useState(undefined);
  const [proveedor] = useGlobal("proveedorExternoCalidad");
  const [cantidadFrutosTotales, setCantidadFrutosTotales] = useState(0);
  const [sumaDefectos, setSumaDefectos] = useState(0);
  const [loadWeightOfVarieties, setLoadWeightOfVarieties] = useState(false)
  const [weightOfVarietiesState, setWeightOfVarietiesState] = useState([])

  useEffect(() => {
    setHabilitadoSelectorCiclo(false);
    setNombreModulo("Calidad")
  }, [])

  useEffect(() => {
    if (proveedor && proveedor.id !== "todos" && state.proveedor !== proveedor.id) { setState({ ...state, proveedor: proveedor.id }); }
  }, [proveedor])

  useEffect(() => {
    setCargando(true);
    if (!datosCargados && invernadero) { obtenerFiltrosCalidadTodos(ciclo); }
    else if (datosCargados, productosYVariedades) { obtenerDatosIniciales(); }
  }, [invernadero, datosCargados, productosYVariedades])
  useEffect(() => {
    setErrores([]);
  }, [state, defectosSeleccionados])

  //Calcular cantidad de frutos totales si es producto con tipo calidad inicial 'cantidad'
  useEffect(() => {
    const { peso_real_caja, peso_promedio_fruto } = state;
    if (parseFloat(peso_real_caja) && parseFloat(peso_promedio_fruto) && producto.tipo_calidad_inicial === TIPO_CANTIDAD) {
      const totalFrutos = peso_real_caja / peso_promedio_fruto;
      const cantidadFrutosTotales = Math.round(totalFrutos);
      setCantidadFrutosTotales(cantidadFrutosTotales);
    }
    else setCantidadFrutosTotales(0)
  }, [state, producto])
  //Sumar total de frutos con defectos o total de pesos de frutos con defectos
  useEffect(() => {
    if (defectosSeleccionados?.length > 0) {
      const sumaDefectos = sumarNumerosArrayPorCampo(defectosSeleccionados, "valor");
      setSumaDefectos(sumaDefectos);
    }
    else setSumaDefectos(0);
  }, [state, defectosSeleccionados])

  useEffect(() => {
    if (defectos) {
      let editados = defectos.map(def => ({ ...def, defecto_ref: def.id, valor: getObjetoPorID(defectosSeleccionados, def.id).valor || "" }))
      setDefectosEditados(editados)
    }
  }, [defectosSeleccionados])

  useEffect(() => {
    if (presentaciones) {
      const presentacion = presentaciones?.find((pres) => pres.id === (state?.presentacion_ref?.value || state?.presentacion_ref))
      if (presentacion?.mezcla && producto?.mezcla) {
        if (weightOfVarietiesState.length === 0) {
          const defaultState = producto.variedades.map(({ id }) => ({ variedad_id: id, valor: null }))
          setWeightOfVarietiesState(defaultState)
        }
        setLoadWeightOfVarieties(true)
      } else {
        setLoadWeightOfVarieties(false)
      }
    }
  }, [state])
  const puedeEditar = () => noHaSidoClausurado(ciclo, ciclos) && usuario.rol != "Auxiliar Empaque" && invernadero && (!invernadero.es_externo || proveedor?.habilitado) && (invernadero.habilitado || invernadero.es_externo)
  const obtenerDatosIniciales = async () => {
    try {
      const producto = getObjetoPorID(productosYVariedades, invernadero.producto_ref)
      const presentacionesFiltrados = getPresentacionesFiltradosYOrdenadosPorInvernadero(presentaciones, invernadero, ORDER_BY_PRESENTACION)
      const mezclaVariedades = producto.mezcla ? producto.variedades : undefined
      const dataSelect = mapDeDataDropdownDePresentaciones(presentacionesFiltrados, clientes, [producto])

      setPresentacionesFiltrados(dataSelect)
      setProducto(producto)
      setMezclaVariedades(mezclaVariedades)

      if (editing) {
        let registroFinal = await obtenerRegistroFinal(ciclo, props.match.params.invernaderoID, registroID)
        if (!registroFinal)
          props.history.goBack()
        else
          procesarRegistroObtenido(registroFinal)
      }
      else {
        let defectosRegistrados = await obtenerDefectosAnteriores()
        setDefectosSeleccionados(defectosRegistrados);
      }
    } catch (error) {
      console.log("ERROR obtener: ", error)
    }

    setCargando(false);
  }
  const procesarRegistroObtenido = (registro) => {
    setState(registro)

    let defectosAAgregar = registro.defectos.map(defecto => {
      let obj = getObjetoPorID(defectos, defecto.defecto_ref)
      return { ...defecto, ...obj }
    })
    if (registro.peso_variedades) {
      setLoadWeightOfVarieties(true)
      setWeightOfVarietiesState(registro.peso_variedades)
    }
    setDefectosSeleccionados(defectosAAgregar);
  }
  const obtenerDefectosAnteriores = async () => {
    let diaActual = obtenerInicioDia(Math.round(Date.now() / 1000));
    let registros = await obtenerRegistrosCalidadFinalDia(ciclo, invernadero.id, diaActual)

    let defectosRegistradosIDs = []
    registros.forEach(registro => {
      defectosRegistradosIDs.push(...registro.defectos.map(el => el.defecto_ref))
    })

    let defectosRegistrados = defectos.filter(def => defectosRegistradosIDs.includes(def.id))
    defectosRegistrados = defectosRegistrados.map(obj => ({ ...obj, defecto_ref: obj.id, valor: "" }))
    return defectosRegistrados
  }
  const handleInputChange = ({ target }) => {
    const copia = DeepClone(state)
    copia[target.name] = target.value
    setState({ ...state, [target.name]: target.value });
  }
  const handleInputDefecto = (index, ev) => {
    let copia = DeepClone(defectosSeleccionados)
    //Para no poder tener varios puntos en los inputs
    if (noHayVariosPuntos(ev.target.value)) {
      copia[index].valor = ev.target.value;
      setDefectosSeleccionados(copia);
    }
  }
  const handleInputsWeightOfVariety = (index, e) => {
    const value = e.target.value
    const weightOfVarietiesStateCopy = DeepClone(weightOfVarietiesState)
    weightOfVarietiesStateCopy[index].valor = value
    setWeightOfVarietiesState(weightOfVarietiesStateCopy)
  }
  const handleInputRacimos = (clave, valor) => {
    let copia = DeepClone(state)
    copia.no_racimos[clave] = valor
    setState(copia)
  }

  const guardar = async () => {
    if (validar()) {
      setCargando(true)
      try {
        let datos = {
          ...state,
          presentacion_ref: state.presentacion_ref?.value || state.presentacion_ref,
          defectos: defectosSeleccionados.map(def => ({ defecto_ref: def.id, valor: def.valor })),
          momento: editing ? state.momento : Math.round(Date.now() / 1000),
        }
        if (loadWeightOfVarieties) datos.peso_variedades = weightOfVarietiesState
        //console.log("GUARDAR DATOS - guardarCalidadFinal -- ",{invid: invernadero.id, datos, registroID})

        await guardarCalidadFinal(ciclo, invernadero.id, datos, registroID)
        setCargando(false)
        props.history.goBack()
      }
      catch (error) {
        console.log("ERROR GUARDAR: ", error);
        setCargando(false)
      }
    }
  }
  const validar = () => getErroresFormulario().length === 0
  const getErroresFormulario = () => {
    let errores = []
    let errorestateNombres = ["peso_real_caja", "peso_promedio_fruto", "presentacion_ref"]
    errores = errorestateNombres.filter(nombre => !state[nombre])

    if (!checkIfStringIsNumber(state[errorestateNombres[0]])) errores.push(`${errorestateNombres[0]}_string`)
    if (!checkIfStringIsNumber(state[errorestateNombres[1]])) errores.push(`${errorestateNombres[1]}_string`)

    if (loadWeightOfVarieties) {
      weightOfVarietiesState.forEach(variety => {
        if (!variety.valor) { errores.push("varieties"); }
        if (!checkIfStringIsNumber(variety.valor)) errores.push("varieties_string")
      })
    }
    defectosSeleccionados.forEach(defecto => {
      if (!defecto.valor) { errores.push("defectos"); }
      if (!checkIfStringIsNumber(defecto.valor)) errores.push("defectos_string")
    })
    if (checarSumaDefectosExcedido() && !errores.includes("defectos") && !errores.includes("peso_real_caja") && !errores.includes("peso_promedio_fruto")) {
      errores.push("sumaDefectos");
    }

    if (!editing && invernadero.es_externo && !state.proveedor) { errores.push("proveedor"); }
    setErrores(errores)
    return errores;
  }

  const checarSumaDefectosExcedido = () => {
    let haExcedido = false;
    const valorAComparar = producto.tipo_calidad_inicial === "PESO" ? state.peso_real_caja : cantidadFrutosTotales;
    defectosSeleccionados.forEach(defecto => {
      if (parseFloat(defecto.valor) > parseFloat(valorAComparar)) { haExcedido = true; }
    })
    return haExcedido;
  }

  return (
    <div className="p-grid p-justify-center">
      <ContenedorHeader col="p-col p-col-auto" titulo="Registro de calidad final" subtituloInv={getProductoYVariedadString(invernadero)}
        invernaderoNombre={invernadero?.es_externo ? <img width="60" alt="icono" src={icono} /> : invernadero?.nombre || ""}
        iconos={`icon-general icon-id bor-${invernadero?.color} bg-${invernadero?.color} ${invernadero?.habilitado ? "" : "Deshabilitado"}`} atras={props.history.goBack} />

      <div className="p-col-12">
        <p className="section-title">Información general</p>
        <div className="card">
          <div className="p-grid">
            {invernadero?.es_externo && <div className="form-group p-col-12 p-md-6">
              <label htmlFor="proveedor">Proveedor externo</label>
              <Dropdown optionLabel="nombre" optionValue="id" name="proveedor" value={state.proveedor} options={proveedores} onChange={handleInputChange} disabled={!puedeEditar()} />
              {errores.includes("proveedor") && <Message severity="error" text="Todos los defectos deben tener un valor" />}
            </div>}

            <DropdownPresentacionesHTG name="presentacion_ref" options={presentacionesFiltrados} presentaciones={presentaciones} md={6} col={12} placeholder="Seleccionar una presentación"
              onChange={handleInputChange} value={state.presentacion_ref} optionValue="id" optionLabel="presentacion" label="Presentación" disabled={!puedeEditar()} />
            {errores.includes("presentacion_ref") && <Message severity="error" text="Este campo es requerido" />}

            <div className="form-group p-col-12 p-md-6">
              <label htmlFor="peso_real_caja">Peso real de la caja (kg)</label>
              <InputText id="peso_real_caja" name="peso_real_caja" keyfilter="pnum" value={state.peso_real_caja} onChange={handleInputChange} disabled={!puedeEditar()} />
              {errores.includes("peso_real_caja") && <Message severity="error" text="Este campo es requerido" />}
              {errores.includes("peso_real_caja_string") && <Message severity="error" text="Este campo solo acepta números" />}
            </div>

            <div className="form-group p-col-12 p-md-6">
              <label htmlFor="peso_promedio_fruto">Peso del fruto (kg)</label>
              <InputText id="peso_promedio_fruto" keyfilter="pnum" name="peso_promedio_fruto" value={state.peso_promedio_fruto} onChange={handleInputChange} disabled={!puedeEditar()} />
              {errores.includes("peso_promedio_fruto") && <Message severity="error" text="Este campo es requerido"></Message>}
              {errores.includes("peso_promedio_fruto_string") && <Message severity="error" text="Este campo solo acepta números"></Message>}
            </div>
            {mezclaVariedades && <div className="form-group p-col-12 p-md-6">
              <label htmlFor="subVariedad_ref">Variedad</label>
              <Dropdown optionLabel="nombre" optionValue="id" name="subVariedad_ref" value={state.subVariedad_ref} options={mezclaVariedades} onChange={handleInputChange}
                disabled={!puedeEditar()} />
            </div>}
          </div>
        </div>
      </div>
      {loadWeightOfVarieties &&
        <div className="p-col-12 pb-0">
          <p className="section-title">Peso de variedades (kg)</p>
          <div className="card">
            <div className="p-grid">
              {producto?.variedades?.map((variedad, index) => {
                const { id, nombre } = variedad;
                return (
                  <div key={`${id}-${index}`} className="form-group p-col-12 p-md-6">
                    <label htmlFor="input_variedad">{nombre}</label>
                    <InputText id={`input_variedad_${index}`} name="input_variedad" type='number' value={weightOfVarietiesState[index]?.valor || ""} onChange={(e) => handleInputsWeightOfVariety(index, e)} disabled={!puedeEditar()} keyfilter="pnum" />
                  </div>)
              })}
            </div>
          </div>
          {errores.includes("varieties") && <Message severity="error" text="Todas las variedades deben tener un valor" />}
          {errores.includes("varieties_string") && <Message severity="error" text="Solo se aceptan números" />}
        </div>}

      {producto && producto.tipo_calidad_inicial !== "PESO" && <SeccionFormulario titulo="# de racimos con cuenta de frutos">
        <ContenedorInput col="12" md="6" sm="4" label="4 frutos">
          <InputText value={state["no_racimos"]["4"]} type='number' onChange={(e) => handleInputRacimos("4", e.target.value)} keyfilter="int" />
        </ContenedorInput>
        <ContenedorInput col="12" md="6" sm="4" label="5 frutos">
          <InputText value={state["no_racimos"]["5"]} type='number' onChange={(e) => handleInputRacimos("5", e.target.value)} keyfilter="int" />
        </ContenedorInput>
        <ContenedorInput col="12" md="6" sm="4" label="6 frutos">
          <InputText value={state["no_racimos"]["6"]} type='number' onChange={(e) => handleInputRacimos("6", e.target.value)} keyfilter="int" />
        </ContenedorInput>
      </SeccionFormulario>}

      <div className="p-col-12 pb-0">
        <p className="section-title">Defectos ({producto?.tipo_calidad_inicial === "PESO" ? "Kg" : "cantidad"} de frutos con defectos)</p>
        <div className="card">
          <div className="p-grid">
            {defectosSeleccionados.map((defecto, index) => {
              return <div key={index} className="form-group p-col-12 p-md-6">
                <label htmlFor="input_defecto">{defecto.nombre}</label>
                <InputText id={`input_defecto_${index}`} name="input_defecto" type='number' value={defecto.valor} onChange={(e) => handleInputDefecto(index, e)} disabled={!puedeEditar()} keyfilter="num" />
              </div>
            })}
          </div>
        </div>
        {errores.includes("defectos") && <Message severity="error" text="Todos los defectos deben tener un valor" />}
        {errores.includes("defectos_string") && <Message severity="error" text="Solo se aceptan números" />}
        {errores.includes("sumaDefectos") &&
          <>
            {producto.tipo_calidad_inicial === "PESO"
              ? <Message severity="error" text={`Los kg de frutos con defectos no puede exceder ${state.peso_real_caja}Kg`} />
              : <Message severity="error" text={`La cantidad de frutos con defectos no puede exceder ${cantidadFrutosTotales}`} />}
          </>}

        <ModalSeleccionarDefectos visible={mostrarModalDefectos} onHide={() => setMostrarModalDefectos(false)} defectosSeleccionados={defectosSeleccionados} defectos={defectosEditados} setDefectosSeleccionados={(e) => setDefectosSeleccionados(e.value)} />

        <div className="p-grid p-justify-end btn-row">
          {puedeEditar() && <Button onClick={() => setMostrarModalDefectos(true)} label="+ Modificar defectos" />}
        </div>
      </div>

      <div className="p-col-12 pb-0">
        <p className="section-title">Información adicional</p>
        <div className="card">
          <div className="p-grid">
            <div className="form-group p-col-12">
              <label htmlFor="comentario">Comentario (opcional)</label>
              <InputTextarea rows={5} cols={30} autoResize={true} id="comentario" name="comentario" value={state.comentario} onChange={handleInputChange}
                disabled={!puedeEditar()} />
            </div>
          </div>
        </div>
      </div>

      <div className="p-col-12">
        <div className="p-grid p-justify-end btn-row">
          <Button label="Cancelar" onClick={props.history.goBack} className="p-button-secondary" />
          <Button label="Guardar" disabled={!puedeEditar()} onClick={guardar} />
        </div>
      </div>
    </div>);
}
export default RegistroFinal//305